import _ from 'lodash';

const transformChartTypeSelector = selector => (state, { chartType }) => selector(state, chartType);
export default selectors => _.map(selectors, transformChartTypeSelector);